import { render } from "./CommitInfo.vue?vue&type=template&id=3c10978c&scoped=true"
import script from "./CommitInfo.vue?vue&type=script&lang=js"
export * from "./CommitInfo.vue?vue&type=script&lang=js"

import "./CommitInfo.vue?vue&type=style&index=0&id=3c10978c&scoped=true&lang=css"

import exportComponent from "/working_dir/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c10978c"]])

export default __exports__